import { render, staticRenderFns } from "./outlander.vue?vue&type=template&id=15545223&scoped=true"
import script from "./outlander.vue?vue&type=script&lang=js"
export * from "./outlander.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15545223",
  null
  
)

export default component.exports